import React, { Fragment } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Avatar, Box, Paper, Typography } from "@mui/material";
import useSystemHook from "./../../hooks/SystemHook";
import {capitalize} from "lodash";

const CategorySlider = ({
  categoriesAndTypes,
  activeCategory,
  handleActiveCategoryChange,
}) => {
  const { isMobile, isTablet, isDesktop } = useSystemHook();

  return (
    <Fragment>
      {isMobile === true && (
        <section>
          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={10}
            slidesPerView={2.5}
            loop={true}
            autoplay={{
              delay: 3500,
              disableOnInteraction: true,
            }}
          >
            {categoriesAndTypes.map((category) => {
              return (
                <SwiperSlide key={category.productCategoryName}>
                  <Paper
                    sx={{
                      textAlign: "center",
                      padding: 1,
                      backgroundColor: "#fff",
                      cursor: "pointer",
                      fontWeight: activeCategory === category.productCategoryId ? 600 : 400,
                      minHeight: "10rem",
                      border:
                        activeCategory === category.productCategoryId
                          ? "2px solid red"
                          : "none",
                    }}
                    onClick={() => handleActiveCategoryChange(category.productCategoryId)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Avatar
                        src={category.productCategoryImage}
                        alt={category.productCategoryName}
                        sx={{
                          width: 56,
                          height: 56,
                          mb: 1,
                        }}
                      />
                      <Typography variant="caption">{capitalize(category.productCategoryName.replaceAll("_", " "))}</Typography>
                    </Box>
                  </Paper>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </section>
      )}
      {isMobile === false && (
        <section>
          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={40}
            slidesPerView={4}
            navigation
            loop={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: true,
            }}
          >
            {categoriesAndTypes.map((category) => {
              return (
                <SwiperSlide key={category.productCategoryName}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      cursor: "pointer",
                      fontWeight: activeCategory === category.productCategoryId ? 600 : 400,
                      color: activeCategory === category.productCategoryId ? "black" : "gray",
                      paddingBottom: "4px",
                      marginBottom: "4px",
                      transition: "color 0.3s, border-bottom 0.3s",
                      "&:hover": {
                        color: "black",
                      },
                      width: "fit-content",
                      margin: "0 auto",
                      background: "none",
                      textDecoration: "none",
                      borderBottom:
                        activeCategory === category.productCategoryId
                          ? "3px solid red"
                          : "1px solid red",
                      py: 2,
                    }}
                    onClick={() => handleActiveCategoryChange(category.productCategoryId)}
                  >
                    {capitalize(category.productCategoryName.replaceAll("_", " "))}
                  </Typography>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </section>
      )}
    </Fragment>
  );
};

export default CategorySlider;
